var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressLatLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "#5D6C85",
    strokeWidth: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.586 9.931H10.55l-2.507 3.62-2.507-3.62H3.414L1 15h14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.145 2.285a4.388 4.388 0 0 0-6.205 0c-1.544 1.544-1.717 4.45-.407 6.198l3.51 5.069 3.51-5.07c1.31-1.746 1.136-4.653-.408-6.197zm-3.06 4.508a1.448 1.448 0 1 1 0-2.896 1.448 1.448 0 0 1 0 2.896z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressLatLang);
export default __webpack_public_path__ + "static/media/AddressLatLang.473251f8.svg";
export { ForwardRef as ReactComponent };